import React from 'react';
import LoadingOverlay from '../../../../components/common/LoadingBar';
import loader from "../../../../assets/Image/Loader2.gif";

const LoadingSpinner = () => {
  return <LoadingOverlay loading={true} loader={loader} />;
};

export default LoadingSpinner;
